"use client";

import { motion } from "framer-motion";

export default function HeroSection() {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

        .hero-font{
          font-family:'Plus Jakarta Sans',sans-serif;
        }
      `}</style>

      <section className="hero-font relative pt-14 lg:py-[80px] min-h-screen bg-[#F7F7F5] overflow-hidden flex items-center">
        
        {/* background glow */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[700px] bg-neutral-200 rounded-full blur-3xl opacity-40" />

        <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-10 py-16">
          
          {/* MAIN GRID */}
          <div className="grid lg:grid-cols-2 gap-14 items-center min-h-[80vh]">
            
            {/* LEFT CONTENT */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1 }}
              className="max-w-xl mx-auto lg:mx-0 text-center lg:text-left"
            >
              {/* heading */}   
              <h1 className="mt-4 text-[44px] sm:text-[56px] lg:text-[60px] font-bold leading-[1] tracking-[-3px] text-black">
                Prioritize Your
                <br/>
                <span className="text-[#256ab7]">Business with</span>
                <br />
                Growth and Success
              </h1>

              {/* paragraph */}
              <p className="mt-6 text-[15px] sm:text-[17px] leading-7 sm:leading-8 text-neutral-600 max-w-lg mx-auto lg:mx-0">
               Here at Coolwell HVACR, we offer high-quality HVAC solutions for cooling, heating, and refrigeration needs. Our products are built for long-lasting durability, reliability, and optimal efficiency for both home and office use.
              </p>

              {/* buttons */}
              <div className="mt-9 flex flex-wrap items-center justify-center lg:justify-start gap-4">
                <button className="px-7 py-4 bg-black text-white rounded-full text-sm font-semibold transition hover:opacity-90">
                  Get Started
                </button>

                <button className="px-7 py-4 border border-neutral-300 rounded-full text-sm font-semibold bg-white hover:bg-neutral-100 transition">
                  Learn More
                </button>
              </div>  
            </motion.div>

            {/* RIGHT IMAGE */}
            <motion.div
              initial={{ opacity: 0, x: 40 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              className="relative flex justify-center"
            >
              {/* glow */}
              <div className="absolute w-[300px] sm:w-[400px] h-[300px] sm:h-[400px] bg-neutral-300 rounded-full blur-3xl opacity-40" />

              <div className="relative w-full max-w-[500px]">
                
                {/* top floating card */}
                <div className="absolute -top-4 left-4 sm:-left-4 bg-white border border-neutral-200 rounded-2xl px-4 sm:px-5 py-3 sm:py-4 shadow-lg z-20">
                  <p className="text-xs sm:text-sm text-neutral-500">
                    Trusted by Businesses
                  </p>

                  <h3 className="text-sm sm:text-base font-semibold text-black mt-1">
                    20+ Years Experience
                  </h3>
                </div>

                {/* image */}
                <div className="overflow-hidden rounded-[28px] sm:rounded-[36px] border border-neutral-200 bg-white p-2 sm:p-3 shadow-2xl">
                  <img
                    src="https://images.unsplash.com/photo-1581092921461-eab62e97a780?q=80&w=1200&auto=format&fit=crop"
                    alt="HVAC"
                    className="w-full h-[320px] sm:h-[420px] object-cover rounded-[22px] sm:rounded-[24px]"
                  />
                </div>

                {/* bottom card */}
                <div className="absolute -bottom-4 right-4 bg-black text-white rounded-2xl px-4 sm:px-5 py-3 sm:py-4 shadow-2xl">
                  <p className="text-[11px] sm:text-xs text-neutral-400">
                    Smart Cooling Systems
                  </p>

                  <h3 className="text-base sm:text-lg font-semibold mt-1">
                    Energy Efficient
                  </h3>
                </div>
              </div>
            </motion.div>

          </div>
        </div>
      </section>
    </>
  );
}